<template>
    <div class="ma-0 pa-0"
         style="max-height: 720px;overflow:auto;background-color: #e0e0e0;">
        <!--首页-->
        <div class="page"
             style="position:relative;width: 210mm;height: 296mm;background: white;box-shadow: 0 .5mm 2mm rgba(0, 0, 0, .3);margin: 5mm auto;">
            <div id="virtual-content"
                 class="virtual"
                 style="visibility:hidden;position: absolute;left: 28mm;top: 0px;height: 800mm;overflow: hidden;width: 156mm">
                <div v-html="convert(doc.content.text,true)" class="gw-element"
                     style="text-indent: 2em;line-height: 10.39mm;letter-spacing: -0.4pt;word-break: break-all"
                     :style="{'font-family':doc.content.font,'font-size':doc.content.fontSize}">
                </div>
            </div>

            <!--密级-->
            <doc-secret :urgent-level="doc.urgentLevel" :secret-level="doc.secretLevel"></doc-secret>

            <!--上面要空37mm-->
            <doc-gutter height="35mm"></doc-gutter>

            <div id="gw-draft-org" style="position: relative;height: 225mm;margin-left: 28mm;margin-right: 26mm;">
                <doc-virtual :doc="doc"></doc-virtual>
                <!--标记开始-->
                <div id="page-1-start-flag"
                     class="flag"
                     style="position: absolute;top: 0;left:0;width: 0px;height:0px;z-index: -1;"></div>
                <!--标记结束-->
                <div id="page-1-end-flag"
                     class="flag"
                     style="position: absolute;bottom: 0;left:0;width: 0;height:0;z-index: -1"></div>

                <!--                &lt;!&ndash;虚拟附件&ndash;&gt;-->
                <!--                <div class="virtual" id="virtual-attach" style="visibility: hidden;position: absolute;top: 0;left: 0;">-->
                <!--                    <doc-attachment :item="doc.attachment"></doc-attachment>-->
                <!--                </div>-->
                <!--                &lt;!&ndash;虚拟署名&ndash;&gt;-->
                <!--                <div class="virtual" id="virtual-sign" style="visibility:hidden;position: absolute;top: 0;left: 0;">-->
                <!--                    <doc-sign :item="doc.sign" :seal="doc.seal"></doc-sign>-->
                <!--                </div>-->
                <!--                &lt;!&ndash;虚拟版记&ndash;&gt;-->
                <!--                <div class="virtual" id="virtual-tail" style="visibility: hidden;position: absolute;top: 0;left: 0;">-->
                <!--                    <doc-tail :cc-org="doc.ccOrg" :print-org="doc.printOrg" :to-org="doc.toOrg"></doc-tail>-->
                <!--                </div>-->

                <!--发文机关标志-->
                <doc-draft-org-flag :item="doc.draftOrg"></doc-draft-org-flag>
                <doc-gutter height="11.08mm"></doc-gutter>
                <!--发文字号（不带签发人） 北医所〔2021〕1号-->
                <doc-code v-if="!doc.docCode.bottom" :item="doc.docCode" :draft-people="doc.draftPeople"></doc-code>

                <!--分隔线-->
                <doc-divider :type="doc.divider"></doc-divider>

                <!--发文字号（不带签发人） 北医所〔2021〕1号-->
                <doc-code v-if="doc.docCode.bottom==true" :item="doc.docCode"
                          :draft-people="doc.draftPeople"></doc-code>

                <doc-gutter height="17mm"></doc-gutter>

                <!--标题 仿宋，2号字体，空2行-->
                <doc-title :item="doc.title"></doc-title>
                <!--主送机关-->
                <doc-to-org v-if="doc.toOrg.enable&&!doc.toOrg.bottom" :item="doc.toOrg"></doc-to-org>
                <!--正文-->
                <doc-content id="page-1-content" :html="firstPage.html"></doc-content>
                <!--附件-->
                <doc-attachment v-if="firstPage.showAttachment&&doc.attachment.text&&!multiPages"
                                :item="doc.attachment"></doc-attachment>
                <!--署名-->
                <doc-sign v-if="doc.sign.org&&firstPage.showSign" :item="doc.sign" :seal="doc.seal"></doc-sign>
                <!--版记 仿宋，4号字体，左边留1字 5.54mm-->
                <doc-tail v-if="firstPage.showPrintOrg&&doc.printOrg.enable&&doc.printOrg.text" :to-org="doc.toOrg"
                          :print-org="doc.printOrg"
                          :cc-org="doc.ccOrg"></doc-tail>

            </div>
            <!--分隔线-->
            <doc-divider v-if="doc.divider=='红色双线'" type="上细下粗"></doc-divider>
            <!--页码-->
            <doc-page v-if="doc.page.enable&&!doc.page.hideFirstPage" :item="doc.page"
                      :page="firstPage.pageNumber"></doc-page>

        </div>

        <!--正文页面-->
        <div class="page" v-for="(item,index) in contentPages" :key="index"
             style="position:relative;width: 210mm;height: 296mm;background: white;box-shadow: 0 .5mm 2mm rgba(0, 0, 0, .3);margin: 5mm auto;">
            <!--上面要空37mm-->
            <doc-gutter height="35mm"></doc-gutter>

            <div style="position: relative;height: 225mm;margin-left: 28mm;margin-right: 26mm;">
                <!--正文-->
                <doc-content :html="item.html"></doc-content>
            </div>
            <!--页码-->
            <doc-page :item="doc.page" :page="item.pageNumber"></doc-page>
        </div>

        <!--正文最后一页-->
        <div class="page" v-if="multiPages"
             style="position:relative;width: 211mm;height: 296mm;background: white;box-shadow: 0 .5mm 2mm rgba(0, 0, 0, .3);margin: 5mm auto;">
            <!--上面要空37mm-->
            <doc-gutter height="35mm"></doc-gutter>
            <div style="position: relative;height: 225mm;margin-left: 28mm;margin-right: 25mm;">
                <!--正文-->
                <doc-content :html="lastPage.html"></doc-content>
                <!--附件-->
                <doc-attachment v-if="lastPage.showAttachment" :item="doc.attachment"></doc-attachment>
                <!--签名-->
                <doc-sign v-if="lastPage.showSign" :item="doc.sign" :seal="doc.seal"></doc-sign>
                <!--版记-->
                <doc-tail
                        v-if="lastPage.showPrintOrg&&(doc.printOrg.text||doc.ccOrg.enable||doc.toOrg.bottom)"
                        :to-org="doc.toOrg"
                        :print-org="doc.printOrg"
                        :cc-org="doc.ccOrg"
                ></doc-tail>
            </div>
            <!--页码-->
            <doc-page :item="doc.page" :page="lastPage.pageNumber"></doc-page>
        </div>

        <!--扩展页-->
        <div class="page" v-if="extPage.enable"
             style="position:relative;width: 210mm;height: 296mm;background: white;box-shadow: 0 .5mm 2mm rgba(0, 0, 0, .3);margin: 5mm auto;">
            <!--上面要空37mm-->
            <doc-gutter height="35mm"></doc-gutter>
            <div style="position: relative;height: 225mm;margin-left: 28mm;margin-right: 26mm;">
                <!--附件-->
                <doc-attachment v-if="extPage.showAttachment" :item="doc.attachment"></doc-attachment>
                <!--签名-->
                <doc-sign v-if="extPage.showSign" :item="doc.sign" :seal="doc.seal"></doc-sign>
                <!--版记-->
                <doc-tail
                        v-if="extPage.showPrintOrg&&(doc.printOrg.text||doc.ccOrg.enable||doc.toOrg.bottom)"
                        :to-org="doc.toOrg"
                        :print-org="doc.printOrg"
                        :cc-org="doc.ccOrg"
                ></doc-tail>
            </div>

            <!--页码-->
            <doc-page :item="doc.page" :page="extPage.pageNumber"></doc-page>
        </div>
    </div>
</template>

<script>

    import DocDraftOrgFlag from "./components/DocDraftOrgFlag";
    import DocCode from "./components/DocCode";
    import DocDivider from "./components/DocDivider";
    import DocTitle from "./components/DocTitle";
    import DocToOrg from "./components/DocToOrg";
    import DocContent from "./components/DocContent";
    import DocAttachment from "./components/DocAttachment";
    import DocSign from "./components/DocSign";
    import DocTail from "./components/DocTail";
    import DocPage from "./components/DocPage";
    import DocSecret from "./components/DocSecret";
    import DocGutter from "./components/DocGutter";
    import DocVirtual from "./components/DocVirtual";

    export default {
        components: {
            DocDraftOrgFlag,
            DocCode,
            DocDivider,
            DocTitle,
            DocToOrg,
            DocContent,
            DocAttachment,
            DocSign,
            DocTail,
            DocPage,
            DocSecret,
            DocGutter,
            DocVirtual
        },
        props: {
            value: {}
        },
        name: "DocumentViewer.vue",
        created() {
            if (this.value) {
                this.doc = Object.assign(this.doc, this.value);
            }

        },
        watch: {
            value(val) {
                this.doc = Object.assign(this.doc, val);
            },
            doc: {
                deep: true,
                handler(val) {
                    this.$emit('input', this.doc);
                    this.doUpdate();
                }
            },
            currentPage: {
                deep: true,
                handler() {
                    ++this.pageNumber;
                }
            }
        },
        updated() {
            this.doUpdate();
        },
        data() {
            return {
                doc: {
                    draftOrg: {
                        type: "发文机关",
                        text: '九牧集团文件',
                        font: '方正小标宋简体',
                        fontSize: '48pt',
                        bold: false,
                        align: null,
                        scale: null,
                        enable: true
                    },
                    //签发人
                    draftPeople: {
                        type: "签发人",
                        text: '张三',
                        font: '华文楷体',
                        fontSize: '16pt',
                        align: null,
                        scale: null,
                        enable: false
                    },
                    docCode: {
                        type: "发文字号",
                        text: '京械检办〔2014〕25号',
                        font: '仿宋_GB2312',
                        fontSize: '16pt',
                        enable: true
                    },
                    title: {
                        type: "标题",
                        name: '九牧集团',
                        font: '方正小标宋简体',
                        fontSize: '22pt',
                        enable: true
                    },
                    toOrg: {
                        type: "主送机关",
                        text: '九牧集团',
                        font: '仿宋_GB2312',
                        fontSize: '16pt',
                        bottom: false,
                        enable: true
                    },
                    ccOrg: {
                        type: "抄送机关",
                        text: '各个子公司',
                        font: '仿宋_GB2312',
                        fontSize: '16pt',
                        enable: false
                    },
                    urgentLevel: null,
                    secretLevel: null,
                    divider: "上粗下细",
                    content: {
                        type: "正文",
                        text: "依据我所《科研发展基金项目管理办法》、《苗圃项目管理办法》、《科研项目工作绩效奖励办法》的规定",
                        font: '仿宋_GB2312',
                        fontSize: '16pt',
                        enable: true
                    },
                    attachment: {
                        type: "附件",
                        text: '2014年第一批确定立项科研发展基金项目表\n' +
                            '2014年第一批确定立项苗圃项目表',
                        sequence: true,
                        font: '仿宋_GB2312',
                        fontSize: '16pt'
                    },
                    printOrg: {
                        type: "印发机关",
                        text: '九牧集团',
                        date: '2021年10月23日',
                        font: '仿宋_GB2312',
                        fontSize: '14pt',
                        enable: true
                    },
                    sign: {
                        type: "印发日期",
                        org: '北京市医疗器械检验所',
                        date: '2014年10月15日',
                        font: '仿宋_GB2312',
                        fontSize: '14pt',
                        enable: true
                    },
                    seal: {
                        url: null,
                        height: 0,
                        width: 0
                    },
                    enablePage: true
                },
                currentElement: {
                    type: null,
                    name: null,
                    font: null,
                    fontSize: null,
                    enable: null
                },
                docId: null,
                dataItem: {
                    id: null,
                    name: null,
                    templateFileUrl: null,
                    templateFileId: null,
                    templateFileName: null,
                    description: null,
                },
                contentLines: [],
                pages: [],
                firstPage: {
                    text: null,
                    html: null,
                    lines: [],
                    showAttachment: false,
                    showSign: false,
                    showPrintOrg: false,
                    blankHeight: 0,
                    pageNumber: null
                },
                lastPage: {
                    text: null,
                    html: null,
                    lines: [],
                    showAttachment: false,
                    showSign: false,
                    showPrintOrg: false,
                    blankHeight: 0,
                    pageNumber: null
                },
                extPage: {
                    showAttachment: true,
                    showSign: true,
                    showPrintOrg: true,
                    enable: false,
                    pageNumber: null
                },
                componentTree: {
                    attachment: {
                        height: 0
                    },
                    sign: {
                        height: 0
                    },
                    signOrg: {
                        height: 0
                    },
                    signDate: {
                        height: 0
                    },
                    print: {
                        height: 0
                    },
                    printOrg: {
                        height: 0
                    }
                },
                contentPages: [],
                multiPages: false,
                lastHash: ""
            }
        },

        methods: {
            doUpdate() {
                if (!this.doc || !this.doc.content.text) {
                    return;
                }
                let hash = this.hash(document.getElementById("virtual-content").innerHTML);
                if (this.lastHash == hash) {
                    return;
                }

                //计算各个组件高度
                this.componentTree.attachment.height = document.getElementById("virtual-attach").offsetHeight;
                this.componentTree.sign.height = document.getElementById("virtual-sign").offsetHeight;
                this.componentTree.print.height = document.getElementById("virtual-tail").offsetHeight;

                this.lastHash = hash;
                this.update = false;
                let index = 0;
                let baseOffset = 0;
                let preLineOffset = -1;
                let contentIndex = 0;
                this.contentLines.length = 0;
                this.pages.length = 0;
                let textIndent = true;
                while (true) {
                    let id = 'c-' + index;
                    let ele = document.getElementById(id);
                    if (preLineOffset == -1) {
                        if (!ele) {
                            console.log("无法找到")
                            return;
                        }
                        preLineOffset = ele.offsetTop;
                        baseOffset = ele.offsetTop;
                    }
                    let calElement = ele;
                    if (!ele) {
                        calElement = document.getElementById('c-' + (index - 1));
                    }
                    let cindex = parseInt(calElement.getAttribute("c"));
                    if (!ele) {
                        ++cindex;
                    }
                    if (calElement.offsetTop != preLineOffset || !ele) {
                        let line = {};
                        line.textStart = contentIndex;
                        line.textEnd = cindex;
                        line.offsetTop = preLineOffset - baseOffset;
                        line.height = calElement.offsetTop - preLineOffset;
                        line.textContent = this.doc.content.text.substring(line.textStart, line.textEnd);
                        line.textHtml = this.$tool.text2Html(line.textContent, false, textIndent);
                        textIndent = line.textContent[line.textContent.length - 1] == '\n';
                        preLineOffset = calElement.offsetTop;
                        contentIndex = cindex;
                        this.contentLines.push(line);
                    }
                    if (!ele) {
                        break;
                    }
                    ++index;
                }
                let startEle = document.getElementById("page-1-start-flag");
                let endEle = document.getElementById("page-1-end-flag");
                let contentEle = document.getElementById("page-1-content");
                let lineHeight = this.contentLines[0].height;
                let pageHeight = endEle.offsetTop - startEle.offsetTop;
                let pageLines = Math.trunc(pageHeight / lineHeight);

                //计算第一页
                let firstContentHeight = endEle.offsetTop - contentEle.offsetTop;
                let firstPageLineCount = Math.trunc(firstContentHeight / lineHeight);
                for (let i = 0; i < this.contentLines.length; ++i) {
                    let pageIndex = null;
                    if (i < firstPageLineCount) {
                        pageIndex = 0;
                    } else {
                        pageIndex = Math.trunc((i - firstPageLineCount) / pageLines) + 1;
                    }
                    let currentPage = null;
                    if (pageIndex >= this.pages.length) {
                        currentPage = Object.create(null);
                        currentPage.lines = [];
                        this.pages.push(currentPage)
                    } else {
                        currentPage = this.pages[pageIndex];
                    }
                    currentPage.lines.push(this.contentLines[i]);
                }
                for (let i = 0; i < this.pages.length; ++i) {
                    let text = "";
                    let html = "";
                    let page = this.pages[i];
                    for (let j = 0; j < page.lines.length; ++j) {
                        text = text + page.lines[j].textContent;
                        html = html + page.lines[j].textHtml;
                    }
                    this.pages[i].text = text;
                    this.pages[i].html = html;
                }
                this.firstPage = Object.assign(this.firstPage, this.pages[0]);
                //第一页填充内容后剩下的空白
                this.firstPage.blankHeight = firstContentHeight - this.firstPage.lines.length * lineHeight;
                this.multiPages = this.pages.length > 1;
                if (this.multiPages) {
                    this.lastPage = Object.assign(this.lastPage, this.pages[this.pages.length - 1]);
                    this.lastPage.blankHeight = pageHeight - this.lastPage.lines.length * lineHeight;
                }
                if (this.pages.length > 2) {
                    for (let i = 1; i < this.pages.length - 1; ++i) {
                        this.contentPages.push(this.pages[i]);
                    }
                }

                //计算是否可以容下附件，署名，版记
                let pagePointer = this.firstPage;
                if (this.multiPages) {
                    //如果是多页，肯定是在最后一页
                    pagePointer = this.lastPage;
                }

                let blankH = pagePointer.blankHeight;
                let attachH = this.componentTree.attachment.height;
                let signH = this.componentTree.sign.height;
                let printH = this.componentTree.print.height;
                if (blankH >= attachH) {
                    pagePointer.showAttachment = true;
                    this.extPage.showAttachment = false;
                } else {
                    pagePointer.showAttachment = false;
                    this.extPage.showAttachment = true;
                }

                if (blankH >= (attachH + signH)) {
                    pagePointer.showSign = true;
                    this.extPage.showSign = false;
                } else {
                    pagePointer.showSign = false;
                    this.extPage.showSign = true;
                }

                if (blankH >= (attachH + signH + printH)) {
                    pagePointer.showPrintOrg = true;
                    this.extPage.showPrintOrg = false;
                } else {
                    pagePointer.showPrintOrg = false;
                    this.extPage.showPrintOrg = true;
                }

                //如果容不下需要通过新的页
                this.extPage.enable = this.extPage.showAttachment | this.extPage.showSign | this.extPage.showPrintOrg;

                let pageNumber = this.doc.page.hideFirstPage ? 0 : 1;
                this.firstPage.pageNumber = pageNumber++;
                this.contentPages.forEach(item => item.pageNumber = pageNumber++);
                if (this.multiPages) {
                    this.lastPage.pageNumber = pageNumber++;
                }
                this.extPage.pageNumber = pageNumber++;

                // console.log("blankH==>" + blankH)
                // console.log("attachH==>" + attachH)
                // console.log("signH==>" + signH)
                // console.log("printH==>" + printH)
                // console.log(this.firstPage);
                // console.log(this.contentPages);
                // console.log(this.lastPage);
                // console.log(this.componentTree);
                // console.log(this.extPage);
            },

            hash(content) {
                let hash = 0, i, chr;
                if (content.length === 0) return hash;
                for (i = 0; i < content.length; i++) {
                    chr = content.charCodeAt(i);
                    hash = ((hash << 5) - hash) + chr;
                    hash |= 0;
                }
                return hash;
            },

            selectElement(eleName, event) {
                this.currentElement = this.doc[eleName];
                let ele = document.querySelector("[active]");
                if (ele) {
                    ele.removeAttribute('active');
                    let originClass = ele.getAttribute("class") || '';
                    if (originClass.indexOf("gw-element") == -1) {
                        originClass = originClass + "gw-element";
                        ele.setAttribute('class', originClass);
                    }
                }
                let id = event.target.id;
                let parent = event.target.parentNode;
                while (!id && parent) {
                    id = parent.id;
                    parent = parent.parentNode;
                }
                if (!id) {
                    this.$message.error("找不到父节点");
                    return;
                }
                document.getElementById(id).setAttribute('active', '');
                let originClass = document.getElementById(id).getAttribute("class") || '';
                if (originClass.indexOf("gw-element") != -1) {
                    originClass = originClass.replace("gw-element", "");
                    document.getElementById(id).setAttribute('class', originClass);
                }
            },
            alignJustify() {
                if (this.currentElement) {
                    if (this.currentElement.align == 'justify') {
                        this.currentElement.align = '';
                    } else {
                        this.currentElement.align = 'justify';
                    }
                }
            },
            textScale() {
                if (this.currentElement) {
                    if (this.currentElement.scale == 'scalex(0.66)') {
                        this.currentElement.scale = '';
                    } else {
                        this.currentElement.scale = 'scalex(0.66)';
                    }
                }
            },
            onPreview() {
                let html = document.getElementById("doc-container").innerHTML;
            },
            noNull(content) {
                return content && content.length > 0;
            },

            /**
             * 将文本转换为标准公文html格式
             * @param c
             * @returns {string}
             */
            convert(content, appendId) {
                return this.$tool.text2Html(content, appendId);
            }
        }
    }
</script>